import { withStyles } from '@material-ui/core';

import TitleBlock from './component';
import styles from './styles';

export default withStyles(styles)(TitleBlock);
